module.exports = __webpack_public_path__ + "img/water-experts.bf65df44.jpg";